import React, { Component,useEffect, useState } from 'react';
import Spin from '../../../commonModules/interface/Spin.jsx';
import { BreadCrumb } from './containers/Layout.jsx';
import FormProduct from './products/FormProduct.jsx';
import ListProduct from './products/ListProduct.jsx';
import SingleProduct from './products/SingleProduct.jsx';
import { isEmpty, truncate } from "lodash";
import { Card, Grid, Button, Box, IconButton, Menu, MenuItem } from '@material-ui/core';
import InputText, { InputSelect, InputSelectNative } from '../../../commonModules/interface/form-input-inline.jsx';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import { BarChartOutlined, BarChartRounded, CenterFocusWeakRounded, CodeRounded, CropFreeRounded, MenuRounded, MoreVert, MultilineChartRounded, ShowChartRounded, TimelineRounded, TrendingUpRounded } from '@material-ui/icons';
import FormSubProduct from './products/SubProducts/FormSubProduct.jsx';
import ProductStats from './stats/ProductStats.jsx';
import GenerateQrCode from './products/GenerateQrCode.jsx';
import ConfirmValidation from '../../../commonModules/interface/ConfirmValidation';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Products = (props) => {
    const navigate = useNavigate();

    const [state,setState] = useState({
        pageOfItems:[],
        currentPage:0,
        rowsPerPage:20,

        //Dialog
        dialogDesc:false,

        view : props.new ? "new" : "list",

        breadcrumb:"",
        update:false,
        sending: false,
        photos:{},
        reloadPagination: false,
        singleProd:{},
        openQR: false,
        single:{
            id: "",
            name: ""
        },
        anchorEl: null,
        confirmSupression:false, //Pop-up to confirm supression
    })
      
        const openMenu = (event) => {
          setState(prevState => ({ ...prevState, anchorEl: event.currentTarget }));

        };
      
        const closeMenu = () => {
          setState(prevState => ({ ...prevState, anchorEl: null }));
        };
    
    // CLEAR & DISPLAY
        
    const handleSingle = (product) => {
        setState(prevState => ({...prevState,
                breadcrumb: product.name,
                singleProd:product,
                view: "product"
            }))
        }
        const handleUpdate = (product) => {
            console.log("in handle update")
            setState(prevState => ({...prevState,
                breadcrumb: product.name + " / Modifier",
                product:product,
                oldProduct:product,
                view: "update",
                anchorEl: null
            }))
            return
        }
        const handleSubProduct = (product) => {
            console.log("in handle sub")
            setState(prevState => ({...prevState,
                breadcrumb: product.name + " / Nouveau Sous Produit",
                product: product,
                oldProduct: product,
                view: "sub",
                anchorEl: null
            }))
            return
        }
        const handleRFIDGraph = (product) => {
            console.log("in handle RFID Graph", product)
            // Navigate to RFID Graph page with product_id filter
            // Use ../ to go up one level from /store to /adminpage
            navigate(`../rfid-graph?product_id=${encodeURIComponent(product.id)}`);
            setState(prevState => ({...prevState,
                anchorEl: null
            }))
            return
        }
        const handleNew = () => {
            setState(prevState => ({...prevState,
                view: "new", breadcrumb:"Nouveau"}))
        }
        const handleDeleteProduct = async () =>{
            console.log("[DEBUG] DELETE")

            if (isEmpty(state.singleProd)){
                toast.error("NO PRODUCT SELECT")
                return
            }
            //TO DO 
            try{
                const resp = await props.deleteProduct(state.singleProd)
                toast.info("Supression réussie")
                handleClose()
                setState(prevState => ({...prevState,
                    confirmSupression: false}))
            }catch(err){
                console.log("ERROR "+err.message)
                toast.error("ERROR "+err.message)
            }
            
        }
        const  handleClose = () => {
            console.log("[DEBUG] PRODUCTS HANDLE CLOSE")
            setState(prevState => ({...prevState,
                dialogDesc:false,
                singleProd:{},
                openQR: false,
                view: "list",
                breadcrumb:"",
                anchorEl: null
            }));
        }
        const handleCloseForm = () => {
            console.log("[DEBUG] PRODUCTS HANDLE CLOSE FORM")
            setState(prevState => ({...prevState,
                dialogDesc:false,
                breadcrumb: state.singleProd.name,
                view: "product",
                anchorEl: null
            }));
        }
        
        const onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        setState(prevState => ({...prevState,
            pageOfItems, currentPage, rowsPerPage }));
    }
   
        return(      
            <CardPage 
                title="Produits"
                storehouse
                action={
                    <div>
                        {state.view === "list" &&
                        <>
                        <Button 
                            variant="contained"
                            color="primary"
                            onClick={ handleNew }
                        >
                            Nouveau
                        </Button>
                        </>
                        }
                        {state.view === "product" &&
                        <>
                            <IconButton 
                                color="secondary" 
                                size="medium"
                                onClick={() => setState(prevState => ({...prevState,openQR: true }))}
                                title="QR Code"
                            >
                                <CenterFocusWeakRounded />
                            </IconButton>
                            <IconButton 
                                color="secondary" 
                                size="medium"
                                onClick={() =>setState(prevState => ({...prevState,view: "stats" }))}
                                title="Statistiques"
                            >
                                <TimelineRounded />
                            </IconButton>
                            {/* <Button 
                                variant="contained"
                                color="secondary"
                                onClick={() => handleUpdate(state.singleProd)}
                            >
                                Modifier
                            </Button> */}
                            <IconButton 
                                aria-controls="simple-menu"
                                onClick={openMenu}
                            >
                                <MenuRounded />
                            </IconButton>
                            <Menu
                                id="simple-menu"
                                anchorEl={state.anchorEl}
                                getContentAnchorEl={null}
                                keepMounted
                                open={Boolean(state.anchorEl)}
                                onClose={closeMenu}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                            >
                                <MenuItem onClick={() => handleSubProduct(state.singleProd)}>Créer un sous-produit</MenuItem>
                                <MenuItem onClick={() => setState(prevState => ({...prevState,view: "stats" }))}>Statistiques</MenuItem>
                                <MenuItem onClick={() => handleUpdate(state.singleProd)}>Modifier</MenuItem>
                                <MenuItem onClick={() => handleRFIDGraph(state.singleProd)}>RFID-Graph</MenuItem>
                                <MenuItem onClick={() => setState(prevState => ({...prevState,confirmSupression: true }))}>Supprimer</MenuItem>
                            </Menu>
                        </>
                        }
                    </div>
                }
            >
                {state.sending && <Spin />}
                
                <BreadCrumb breadcrumb={ state.breadcrumb } title="Produits" back={state.view !== "update" ? handleClose : handleCloseForm} />
                
                {state.openQR &&
                    <GenerateQrCode 
                        // {...props} // notif from here
                        handleClose={() => setState(prevState => ({...prevState,openQR: false }))} 
                        product={state.singleProd}
                    />
                }
                {state.view === "new" &&
                    <FormProduct 
                        {...props} // notif from here
                        handleClose={handleClose} 
                    />
                }
                {state.view === "sub" &&
                    <FormSubProduct 
                        {...props} // notif from here
                        handleClose={handleClose} 
                        handleCloseForm={handleCloseForm} 
                        MAIN_PRODUCT={state.product} 
                    />
                }
                {state.view === "update" &&
                    <FormProduct 
                        {...props} // notif from here
                        handleClose={handleClose} 
                        product={state.product} 
                        oldProduct={state.oldProduct} 
                        update
                    />
                }
                {state.confirmSupression &&
                    <ConfirmValidation 
                        open={state.confirmSupression}
                        title="le pointage"
                        handleClose={()=> setState(prevState => ({...prevState, confirmSupression: false}))}
                        handleConfirm={handleDeleteProduct}
                    />
                }
                {state.view === "stats" &&
                    <ProductStats 
                        {...props} 
                        close={handleCloseForm}
                        product={state.singleProd}
                    />
                }
                {state.view === "product" &&
                    <SingleProduct 
                        {...props} 
                        close={handleClose}
                        product={state.singleProd}
                        updateDesc={()=> setState(prevState => ({...prevState, dialogDesc:true }))}
                        update={handleUpdate}
                    />
                }
                {state.view === "list" &&
                    <ListProduct 
                        {...props}
                        {...state}
                        onChangePage={onChangePage}
                        handleSingle={handleSingle}
                        handleNew={handleNew}

                    />
                }
            </CardPage>
        )
}

export default Products

